import { render, staticRenderFns } from "./Ipros.vue?vue&type=template&id=0fbfa095"
import script from "./Ipros.vue?vue&type=script&lang=js"
export * from "./Ipros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports